import { gql } from '@apollo/client';
import { useGraphql } from 'utils/hooks/useGraphql';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { CriteriaTableColumn, CriteriaTableTab } from '../types';
import { AnonCriteriaFragment } from '../constants';

export const GetAnonCriteriasQuery = gql`
  query getAnonCriterias(
    $ids: [Long!]
    $pagination: Pagination
    $filterInfo: AnonUserCriteriaFilterInfoInput
    $sort: Sort
    $search: String
  ) {
    anonUserCriterias(
      ids: $ids
      pagination: $pagination
      filterInfo: $filterInfo
      sort: $sort
      search: $search
    ) {
      info {
        count
      }
      results {
        ...AnonCriteria
      }
    }
  }
  ${AnonCriteriaFragment}
`;

export const useQueryAnonCriterias = (
  stateFilter: CriteriaTableTab,
  searchFilter?: string,
  sortBy?: CriteriaTableColumn,
  sortDirection?: SORT_DIRECTIONS,
  pageNum?: number,
  pageSize?: number,
) => {
  const { data, isLoading, refetch } = useGraphql(GetAnonCriteriasQuery, {
    fetchPolicy: 'network-only',
    variables: {
      ...(stateFilter !== CriteriaTableTab.ALL
        ? { filterInfo: { criteriaState: stateFilter } }
        : {}),
      ...(sortBy && sortDirection
        ? {
            sort: {
              sortBy,
              sortDirection,
            },
          }
        : {}),
      ...(searchFilter
        ? {
            search: searchFilter,
          }
        : {}),
      ...(pageNum && pageSize
        ? {
            pagination: {
              offset: (pageNum - 1) * pageSize,
              limit: pageSize,
            },
          }
        : {}),
    },
  });

  return {
    results: data?.anonUserCriterias?.results ?? [],
    totalCount: data?.anonUserCriterias?.info?.count ?? 0,
    isLoading,
    refetch,
  };
};
